import React, { useState } from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from 'react-multi-lang'
import Configuration from "./configuration";

const Main = ({ obj, setView }) => {
  const history = useHistory();
  const [selectedClient, setSelectedClient] = useState(null);
  const t = useTranslation();
  const location = useParams();
  console.log(location)

  if (obj.user.id_role == 6) localStorage.setItem("view", "commande");
  const goToPage = (client, page) => {
    localStorage.setItem("view", page);
    console.log(client)
    setView(page)
    history.push(`/${client}`);

  };

  const renderClientMenu = (client, obj, industrie) => (


    < div style={{ textAlign: "center" }}>
      <Row>
        <Col md="6 " >


          <button
            className={` m-3 style-btn style-btn-${industrie} `}

            onClick={() => setSelectedClient(null)}
          >
            <img

              src={require(`./assets/img/bg-${client}.png`)}
              alt="icon-profil"
            />

          </button>

        </Col>
        <Col md="6" className="style-flexbloc ">
          <div className="m-3 ">



            <button
              className={"btn m-2 ac-" + industrie}
              style={{

              }}
              onClick={() => goToPage(client, "commande")}
            >
              <i class="fa-solid fa-boxes-stacked mr-1"></i>
              Commande
            </button>

            {obj.user.id_role == 1 || obj.user.id_role == 10 || obj.user.id_role == 3 ?
              <button
                className={"btn m-2 ac-" + industrie}
                style={{

                }}
                onClick={() => goToPage(client, "releve")}
              >
                <i class="fa-solid fa-arrow-trend-up mr-1"></i>
                Relevé
              </button> : ""}


            {obj.user.id_role == 1 || obj.user.id_role == 10 ?
              <button
                className={"btn m-2 ac-" + industrie}
                style={{

                }}
                onClick={() => goToPage(client, "rapportcommercial")}
              >
                <i class="fa-solid fa-square-poll-vertical mr-1"></i>
                Rapport.C
              </button>
              : ""
            }

            {obj.user.id_role == 1 || obj.user.id_role == 10 ?
              <button
                className={"btn m-2 ac-" + industrie}
                style={{

                }}
                onClick={() => goToPage(client, "parametre")}
              >
                <i class="fa-solid fa-gears mr-1"></i>   Paramètre
              </button> : ""
            }

            {/* <button
              className="btn m-2"
              onClick={() => setSelectedClient(null)}
              style={{
                backgroundColor: "black",
                color: "#fff",
                width: "120px",
                height: "45px",
                fontSize: "16px",
                border: "none"
              }}

            >
              back
            </button> */}
          </div>
        </Col>
      </Row>
    </div >
  );

  return (
    <Container fluid className="main-page">


      {/* <div className="style-bg"   >
            <img

              src={require("./assets/img/5.png")}
              alt="bg"
            />
          </div> */}
      <div className="slogan">
        <h2> {t("bienvenue")} {obj.user.nom_prenom}</h2>
        <h4>Sélectionnez votre laboratoire pour commencer votre expérience client et passer vos commandes en toute simplicité.</h4>
      </div>
      {console.log("ici", selectedClient)}
      {!selectedClient ? (
        <div style={{ textAlign: "center" }}>
          <Row>
            {obj.id_site.includes("2") && (
              <Col md="6">
                <button
                  className={` m-3 style-btn style-btn-industrie2 `}

                  onClick={() => {
                    setSelectedClient(Configuration.industrie2sans)
                    if (obj.user.id_role == 5 || obj.user.id_role == 6 || obj.user.id_role == 4 || obj.user.id_role == 3 || obj.user.id_role == 13 || obj.user.id_role == 12 || obj.user.id_role == 3 || obj.user.id_role == 11) { goToPage(Configuration.industrie2sans, "commande") }
                  }}
                >
                  <img

                    src={require(`./assets/img/bg-${Configuration.industrie2sans}.png`)}
                    alt="icon-profil"
                  />

                </button></Col>

            )}
            {obj.id_site.includes("3") && (<Col md="6">
              <button
                className={` m-3 style-btn style-btn-industrie3 `}

                onClick={() => {
                  setSelectedClient(Configuration.industrie3sans)
                  if (obj.user.id_role == 5 || obj.user.id_role == 6 || obj.user.id_role == 4 || obj.user.id_role == 3 || obj.user.id_role == 13 || obj.user.id_role == 12 || obj.user.id_role == 3 || obj.user.id_role == 11) { goToPage(Configuration.industrie3sans, "commande") }
                }}

              >
                <img
                  src={require(`./assets/img/bg-${Configuration.industrie3sans}.png`)}
                  alt="icon-profil"
                />

              </button></Col>

            )}
          </Row>
        </div>
      ) : (
        renderClientMenu(selectedClient, obj, selectedClient == Configuration.industrie2sans ? "industrie2" : selectedClient == Configuration.industrie3sans ? "industrie3" : "")
      )}


    </Container>
  );
};

export default Main;
